module.exports = __webpack_public_path__ + "static/media/loader.ed2c4fc1.gif";